<template>
    <div v-if="visible">
        <el-dialog title="学生评价统计详情" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="850px">    
            <div class="container">
                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    v-loading="loading"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border>
                    <el-table-column type="index" fixed label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column prop="name" fixed label="姓名"  :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="gradeName" fixed label="年级名称"  :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="className" fixed label="班级名称"  :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="mentorClassName" fixed label="导师班名称"  width="100px" v-if="form.classModel==2"></el-table-column>
                    <el-table-column prop="mentorName" fixed label="导师姓名"  :show-overflow-tooltip="true" v-if="form.classModel==2"></el-table-column>
                    <el-table-column prop="" label="奖章/积分" v-if="form.isHaveIcon">
                        <template slot-scope="scope"> 
                            {{scope.row.medalCount}}枚/{{scope.row.score}}分 
                        </template>
                    </el-table-column>
                    <div v-if="form.isHaveGroup">
                        <el-table-column prop="sumScore" label="复合积分"></el-table-column>
                    </div>
                    <div v-else>
                        <el-table-column prop="score" label="复合积分"></el-table-column>
                    </div>
                    <div v-if="!form.isHaveIcon" >
                        <el-table-column prop="exchangeScore" label="可兑换积分"  width="90"></el-table-column>
                    </div>
                    <div v-if="form.isHaveGroup">
                        <el-table-column prop="score" label="个人积分" width="90"></el-table-column>
                        <el-table-column prop="" label="个人积分-加分" width="100">
                            <template slot-scope="scope">
                                {{scope.row.praiseScore}}分
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="个人积分-减分" width="100">
                            <template slot-scope="scope">
                                {{scope.row.improveScore}}分
                            </template>
                        </el-table-column>
                        <el-table-column prop="groupScore" label="小组积分" width="80"></el-table-column>
                        <el-table-column prop="groupPraiseScore"  label="小组积分-加分" width="100"></el-table-column>
                        <el-table-column prop="groupImproveScore" label="小组积分-减分" width="100"></el-table-column>
                        <el-table-column prop="groupAvgScore" label="小组均分" width="80"></el-table-column>
                    </div>
                    <div v-else>
                        <el-table-column prop="score" label="个人积分" width="90"></el-table-column>
                        <el-table-column prop="" label="个人积分-加分" width="100">
                            <template slot-scope="scope">
                                {{scope.row.praiseScore}}分
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="个人积分-减分" width="100">
                            <template slot-scope="scope">
                                {{scope.row.improveScore}}分
                            </template>
                        </el-table-column>
                    </div>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="common.page"
                        :page-size="common.pageSize"
                        :page-sizes="common.allSizes"
                        layout="total,sizes, prev, pager, next, jumper"
                        :total="common.total">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    startDate:"",
                    endDate:"",
                    className:"", // 班级名称
                    gradeName:"", // 年级名称
                    mentorName:"", // 导师名称
                    classModel:"", // 1-行政班，2-导师班
                    isHaveIcon:"",
                    isHaveGroup:"",
                    queryUserId:""
                },
                data:[],
            }
        },
        created:function () {
        },
        methods:{
            init(id,startDate,endDate,formObj){
                this.data = [];
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                
                this.form.id=id; // 荣誉版设置ID
                this.form.startDate=startDate;
                this.form.endDate=endDate;
                this.form.gradeName=formObj.gradeName;
                this.form.className=formObj.className;
                this.form.mentorName=formObj.mentorName;
                this.form.classModel=formObj.classModel;
                this.form.queryUserId=formObj.queryUserId;

                // console.log('form表单',this.form);
                // return;
                // 获取数据列表
                this.common.page=1;
                this.getData();
            },
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.evaluateDetailArchiveInfoListtUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    id:this.form.id,
                    startDate:this.form.startDate,
                    endDate:this.form.endDate,
                    queryGradeName:this.form.gradeName,
                    queryClassName:this.form.className,
                    queryMentorName:this.form.mentorName,
                    classModel:this.form.classModel,
                    queryTeacherId: this.form.queryUserId
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                       // 是否有图标，有小组
                       this.form.isHaveGroup = res.data.isHaveGroup;
                       this.form.isHaveIcon = res.data.isHaveIcon;

                       console.log('isHaveGroup',this.form.isHaveGroup,typeof(this.form.isHaveGroup));
                       console.log('isHaveIcon',this.form.isHaveIcon,typeof(this.form.isHaveIcon));
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }else{
                    return true;
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/StudentEvaluateInfo.vue